module.exports = __webpack_public_path__ + "sc.20bcebb3ff9e836bf04e.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/sc.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/sc.svg
// module chunks = styles